// extracted by mini-css-extract-plugin
export default {"root":"IconButton_root__pXEM3","small":"IconButton_small__6+rAj"};